export const colorList = {
  unverified: 'warning',
  correct: 'success',
  incorrect: 'error',
  incomplete: 'blue',
  unavailable: 'grey',
};
